export default __webpack_public_path__ + "static/media/VISHWAs.ff101d83.png";